import i18n from '@/api/i18n/i18n';

export const LOG_TYPES_DETAILS = {
  1: [
    {
      text: i18n.t('pages.columns.caption'),
      field: 'caption',
    },
    {
      text: i18n.t('pages.columns.text'),
      field: 'keys',
    },
    {
      text: i18n.t('pages.columns.path'),
      field: 'path',
    },
  ],
  2: [
    {
      text: i18n.t('pages.columns.caption'),
      field: 'caption',
    },
    {
      text: i18n.t('pages.columns.path'),
      field: 'path',
    },
    {
      text: i18n.t('pages.columns.screenshot'),
      field: 'ssh',
    },
  ],
  3: [
    {
      text: i18n.t('pages.columns.caption'),
      field: 'caption',
    },
    {
      text: i18n.t('pages.columns.path'),
      field: 'path',
    },
    {
      text: i18n.t('pages.columns.category'),
      field: 'category',
    },
    {
      text: i18n.t('pages.columns.program'),
      field: 'name',
    },
    {
      text: i18n.t('pages.columns.action'),
      field: 'status',
    },
  ],
  4: [
    {
      text: i18n.t('pages.columns.path'),
      field: 'path',
    },
    {
      text: i18n.t('pages.columns.action'),
      field: 'action',
    },
    // {
    //   text: i18n.t('pages.columns.size'),
    //   field: 'size',
    // },
    // {
    //   text: 'MD5',
    //   field: 'crc',
    // },
  ],
  5: [
    {
      text: i18n.t('pages.columns.caption'),
      field: 'caption',
    },
    {
      text: i18n.t('pages.columns.dataType'),
      field: 'type',
    },
    {
      text: i18n.t('pages.columns.clipboardContent'),
      field: 'text',
    },
    {
      text: i18n.t('pages.columns.screenshot'),
      field: 'ssh',
    },
    {
      text: i18n.t('logTypes.file'),
      field: 'file',
    },
  ],
  6: [
    {
      text: i18n.t('pages.columns.printer'),
      field: 'printer',
    },
    {
      text: i18n.t('pages.columns.document'),
      field: 'document',
    },
    {
      text: i18n.t('pages.columns.printedPages'),
      field: 'pagesPrinted',
    },
    {
      text: i18n.t('pages.columns.copies'),
      field: 'copies',
    },
    {
      text: i18n.t('pages.columns.computer'),
      field: 'computer',
    },
    {
      text: i18n.t('pages.columns.cost'),
      field: 'cost',
    },
    {
      text: i18n.t('logTypes.file'),
      field: 'file',
    },
  ],
  7: [
    {
      text: i18n.t('pages.columns.caption'),
      field: 'caption',
    },
    {
      text: i18n.t('pages.columns.action'),
      field: 'action',
    },
    {
      text: i18n.t('pages.columns.path'),
      field: 'path',
    },
  ],
  8: [
    {
      text: i18n.t('pages.columns.action'),
      field: 'action',
    },
    {
      text: i18n.t('pages.columns.diskLetter'),
      field: 'driveChar',
    },
    {
      text: i18n.t('pages.columns.diskLabel'),
      field: 'driveLabel',
    },
    {
      text: i18n.t('pages.columns.diskType'),
      field: 'driveType',
    },
    {
      text: i18n.t('pages.columns.fileSystem'),
      field: 'filesystem',
    },
    {
      text: i18n.t('pages.columns.serialNumber'),
      field: 'serial',
    },
  ],
  10: [
    {
      text: i18n.t('pages.columns.caption'),
      field: 'caption',
    },
    {
      text: i18n.t('pages.columns.category'),
      field: 'category',
    },
    {
      text: i18n.t('pages.columns.link'),
      field: 'link',
    },
    {
      text: i18n.t('pages.columns.timeSite'),
      field: 'duration',
    },
  ],
  11: [
    {
      text: i18n.t('pages.columns.action'),
      field: 'action',
    },
  ],
  14: [
    {
      text: i18n.t('pages.columns.action'),
      field: 'action',
    },
    {
      text: i18n.t('pages.columns.filename'),
      field: 'filename',
    },
    {
      text: i18n.t('pages.columns.filesize'),
      field: 'filesize',
    },
    {
      text: i18n.t('pages.columns.available'),
      field: 'available',
    },
    {
      text: i18n.t('pages.columns.source'),
      field: 'source',
    },
    {
      text: 'MD5',
      field: 'crc',
    },
    {
      text: 'file',
      field: 'file',
    },
  ],
  15: [
    {
      text: i18n.t('pages.columns.dateSend'),
      field: 'dateSend',
    },
    {
      text: i18n.t('pages.columns.subject'),
      field: 'subject',
    },
    {
      text: i18n.t('pages.columns.from'),
      field: 'from',
    },
    {
      text: i18n.t('pages.columns.to'),
      field: 'to',
    },
    {
      text: i18n.t('pages.columns.text'),
      field: 'text',
    },
    {
      text: i18n.t('pages.attachedFiles'),
      field: 'attachments',
    },
  ],
  18: [
    {
      text: i18n.t('pages.columns.computer'),
      field: 'computerName',
    },
    {
      text: i18n.t('pages.columns.action'),
      field: 'action',
    },
  ],
  19: [
    {
      text: i18n.t('pages.columns.filename'),
      field: 'filepath',
    },
    {
      text: i18n.t('pages.columns.action'),
      field: 'action',
    },
    {
      text: i18n.t('pages.columns.accessRights'),
      field: 'fileaccess',
    },
  ],
  20: [
    {
      text: i18n.t('pages.columns.dateSend'),
      field: 'dateSend',
    },
    {
      text: i18n.t('pages.columns.subject'),
      field: 'subject',
    },
    {
      text: i18n.t('pages.columns.from'),
      field: 'from',
    },
    {
      text: i18n.t('pages.columns.to'),
      field: 'to',
    },
    {
      text: i18n.t('pages.columns.text'),
      field: 'text',
    },
    {
      text: i18n.t('pages.columns.messageType'),
      field: 'type',
    },
    {
      text: i18n.t('pages.columns.mailServer'),
      field: 'server',
    },
  ],
  21: [
    {
      text: i18n.t('pages.columns.link'),
      field: 'url',
    },
    {
      text: i18n.t('pages.columns.server'),
      field: 'host',
    },
  ],
  22: [
    {
      text: i18n.t('pages.columns.buddy'),
      field: 'buddy',
    },
    {
      text: i18n.t('pages.columns.socialNetwork'),
      field: 'socialDomain',
    },
    {
      text: i18n.t('pages.columns.text'),
      field: 'text',
    },
  ],
  23: [
    {
      text: i18n.t('pages.columns.messenger'),
      field: 'messenger',
    },
    {
      text: i18n.t('pages.columns.buddy'),
      field: 'interlocutor',
    },
    {
      text: i18n.t('pages.columns.messageType'),
      field: 'direction',
    },
    {
      text: i18n.t('pages.columns.text'),
      field: 'text',
    },
    {
      text: i18n.t('pages.columns.messengerName'),
      field: 'usernameMessenger',
    },
    {
      text: i18n.t('logTypes.file'),
      field: 'file',
    },
  ],
  25: [
    {
      text: i18n.t('pages.columns.action'),
      field: 'action',
    },
    {
      text: i18n.t('pages.columns.deviceType'),
      field: 'hardwareType',
    },
    {
      text: i18n.t('pages.columns.description'),
      field: 'description',
    },
  ],
  26: [
    {
      text: i18n.t('pages.columns.searchEngine'),
      field: 'engine',
    },
    {
      text: i18n.t('pages.columns.queryText'),
      field: 'query',
    },
  ],
};
